import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import api from 'lib/api';
import { get_operations } from 'lib/patch';
export var GET_ASSESSMENTS_COURSES = 'GET_ASSESSMENTS_COURSES';
export var GET_ASSESSMENT = 'GET_ASSESSMENT';
export var GET_ASSESSMENTS = 'GET_ASSESSMENTS';
export var CREATE_ASSESSMENTS = 'CREATE_ASSESSMENTS';
export var DELETE_ASSESSMENT = 'ASSESSMENTS_DELETE_ASSESSMENTS';
export var DELETE_ASSESSMENTS_DETAIL = 'ASSESSMENTS_DELETE_ASSESSMENTS_DETAIL';
export var GET_STUDENT_ASSESSMENTS = 'GET_STUDENT_ASSESSMENTS';
export var UPDATE_ASSESSMENT = 'UPDATE_ASSESSMENT';
export var UPDATE_ASSESSMENT_STATUS = 'UPDATE_ASSESSMENT_STATUS';
export var GET_STUDENT_ASSESSMENT_OVERVIEW = 'GET_STUDENT_ASSESSMENT_OVERVIEW';
export var GET_MATRIX_ASSESSMENT_STATISTIC = 'GET_MATRIX_ASSESSMENT_STATISTIC';
export var GET_STUDENT_COURSES_GOALS = 'ASSESSMENTS_GET_STUDENT_COURSES_AND_GOALS';
export var GET_STUDENT_ASSESSMENT_STATISTICS = 'ASSESSMENTS_GET_STUDENT_ASSESSMENT_STATISTICS';
export var RESET_MATRIX_ASSESSMENT_STATISTICS = 'RESET_MATRIX_ASSESSMENT_STATISTICS';
export var CLEAR_MATRIX_ASSESSMENT_OVERVIEW = 'CLEAR_MATRIX_ASSESSMENT_OVERVIEW';
export var RESET_USER_ASESSMENT_STATISTIC = 'RESET_USER_ASSESSMENT_STATISTIC';
export var GET_SECTIONS_FROM_ASSESSMENTS = 'GET_SECTIONS_FROM_ASSESSMENTS';
export var GET_USER_ASSESSMENTS_STATISTIC_PROGRESS = 'GET_USER_ASSESSMENTS_STATISTIC_PROGRESS';
export var GET_ASSESSMENTS_BY_STUDENT = 'GET_ASSESSMENTS_BY_STUDENT';
export var GET_ASSESSMENTS_BY_STUDENT_AND_SECTION = 'GET_ASSESSMENTS_BY_STUDENT_AND_SECTION';
export var CLEAR_ASSESSMENTS = 'CLEAR_ASSESSMENTS';
export var EXPORT_ASSESSMENT = 'ASSESSMENTS_EXPORT_ASSESSMENT';
export var EXPORT_ASSESSMENT_FOR_SECTION = 'EXPORT_ASSESSMENT_FOR_SECTION';
export var EXPORT_ASSESSMENT_FOR_SCHOOLID = 'EXPORT_ASSESSMENT_FOR_SCHOOLID';
export var CREATE_ASSESSMENTS_STUDENT = 'CREATE_ASSESSMENTS_STUDENT';
export var getCoursesUsedWithinMySections = function getCoursesUsedWithinMySections(from, to) {
  return {
    type: GET_ASSESSMENTS_COURSES,
    payload: new Promise(function (resolve) {
      api.get("assessments/v2/courses?fromDate=".concat(from, "&toDate=").concat(to)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getAssessment = function getAssessment(type, id, userId) {
  return {
    type: GET_ASSESSMENT,
    payload: new Promise(function (resolve) {
      api.get("".concat(type, "/").concat(id, "/assessments/").concat(userId, "/")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var createExportAssessment = function createExportAssessment(studentId) {
  return {
    type: EXPORT_ASSESSMENT,
    payload: new Promise(function (resolve) {
      api.post("assessments/export?fromStudentId=".concat(studentId), "").then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var createExportAssessmentForSectionId = function createExportAssessmentForSectionId(sectionId) {
  return {
    type: EXPORT_ASSESSMENT_FOR_SECTION,
    payload: new Promise(function (resolve) {
      api.post("assessments/export?fromSectionId=".concat(sectionId), "").then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var createExportAssessmentForSchoolId = function createExportAssessmentForSchoolId(schoolId) {
  return {
    type: EXPORT_ASSESSMENT_FOR_SCHOOLID,
    payload: new Promise(function (resolve) {
      api.post("assessments/export?fromSchoolId=".concat(schoolId), "").then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getPlanAssessments = function getPlanAssessments(id) {
  return {
    type: GET_ASSESSMENTS,
    payload: new Promise(function (resolve) {
      api.get("assessments/v2/plans/".concat(id)).then(function (response) {
        if (response.status > 300) {
          resolve([]);
          return false;
        }

        resolve(response.data);
      });
    })
  };
};
export var createAssessments = function createAssessments(values) {
  return {
    type: CREATE_ASSESSMENTS,
    payload: new Promise(function (resolve) {
      api.post('assessments/v2', values).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  resolve(response.data);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    })
  };
};
export var createStudentAssessment = function createStudentAssessment(values) {
  return {
    type: CREATE_ASSESSMENTS_STUDENT,
    payload: new Promise(function (resolve) {
      api.post('assessments/v2/student', values).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  resolve(response.data);

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    })
  };
};
export var updateAssessment = function updateAssessment(values, assessment) {
  return {
    type: UPDATE_ASSESSMENT,
    payload: new Promise(function (resolve) {
      var operations = get_operations(assessment, values);

      if (operations.length > 0) {
        api.patch("assessments/v2/".concat(values.id), assessment, operations).then(function (response) {
          resolve(response.data);
        });
      } else {
        resolve(values);
      }
    })
  };
};
export var updateAssessmentStatus = function updateAssessmentStatus(assessmentId, status) {
  return {
    type: UPDATE_ASSESSMENT_STATUS,
    payload: new Promise(function (resolve) {
      api.put("assessments/status?assessmentId=".concat(assessmentId, "&status=").concat(status), null).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var deleteAssessment = function deleteAssessment(assessmentId) {
  return {
    type: DELETE_ASSESSMENT,
    payload: new Promise(function (resolve) {
      api["delete"]("assessments/" + assessmentId).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var deleteAssessmentDetails = function deleteAssessmentDetails(assessmentId) {
  return {
    type: DELETE_ASSESSMENTS_DETAIL,
    payload: new Promise(function (resolve) {
      api["delete"]("assessments/" + assessmentId + "/details").then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var deleteAssessmentDetail = function deleteAssessmentDetail(assessmentId, detailId) {
  return {
    type: DELETE_ASSESSMENTS_DETAIL,
    payload: new Promise(function (resolve) {
      api["delete"]("assessments/".concat(assessmentId, "/details/").concat(detailId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getStudentAssesmentByGroup = function getStudentAssesmentByGroup(userid, groupid) {
  return {
    type: GET_STUDENT_ASSESSMENTS,
    payload: new Promise(function (resolve) {
      api.get("assessments/section/".concat(groupid, "/student/").concat(userid)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getAssignmentAssessment = function getAssignmentAssessment(id) {
  return {
    type: GET_ASSESSMENTS,
    payload: new Promise(function (resolve) {
      api.get("assessments/v2/assignments/".concat(id)).then(function (response) {
        if (response.status != 200) {
          resolve(null);
        } else {
          resolve(response.data);
        }
      });
    })
  };
};
export var getStudentAssessmentOverview = function getStudentAssessmentOverview(sectionId, studentId) {
  return {
    type: GET_STUDENT_ASSESSMENT_OVERVIEW,
    payload: new Promise(function (resolve) {
      api.get("assessments/section/".concat(sectionId, "/student/").concat(studentId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getStudentAssessmentOverviewByDate = function getStudentAssessmentOverviewByDate(sectionId, studentId, start, end) {
  return {
    type: GET_STUDENT_ASSESSMENT_OVERVIEW,
    payload: new Promise(function (resolve) {
      api.get("assessments/section/".concat(sectionId, "/student/").concat(studentId, "/start/").concat(start, "/end/").concat(end)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getMatrixAssessmentStatistic = function getMatrixAssessmentStatistic(sectionId, studentId, matrixId) {
  return {
    type: GET_MATRIX_ASSESSMENT_STATISTIC,
    payload: new Promise(function (resolve) {
      api.get("assessments/section/".concat(sectionId, "/student/").concat(studentId, "/matrix/").concat(matrixId)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var resetMatrixAssessmentStatistics = function resetMatrixAssessmentStatistics() {
  return {
    type: RESET_MATRIX_ASSESSMENT_STATISTICS,
    payload: []
  };
};
export var clearAssessments = function clearAssessments() {
  return {
    type: CLEAR_ASSESSMENTS,
    payload: []
  };
};
export var resetUserAssessmentStatistic = function resetUserAssessmentStatistic() {
  return {
    type: RESET_USER_ASESSMENT_STATISTIC,
    payload: true
  };
};
export var getMatrixAssessmentOverviewByDate = function getMatrixAssessmentOverviewByDate(sectionId, studentId, matrixId, start, end) {
  return {
    type: GET_MATRIX_ASSESSMENT_STATISTIC,
    payload: new Promise(function (resolve) {
      api.get("assessments/section/".concat(sectionId, "/student/").concat(studentId, "/matrix/").concat(matrixId, "/start/").concat(start, "/end/").concat(end)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var clearMatrixAssessmentOverview = function clearMatrixAssessmentOverview() {
  return {
    type: CLEAR_MATRIX_ASSESSMENT_OVERVIEW,
    payload: true
  };
};
export var getUserAssessmentStatistics = function getUserAssessmentStatistics(studentId, start, end) {
  return {
    type: GET_STUDENT_ASSESSMENT_OVERVIEW,
    payload: new Promise(function (resolve) {
      api.get("assessments/student/".concat(studentId, "/start/").concat(start, "/end/").concat(end)).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getSectionsFromAssessments = function getSectionsFromAssessments(userId, startDate, endDate) {
  return {
    type: GET_SECTIONS_FROM_ASSESSMENTS,
    payload: new Promise(function (resolve) {
      api.get("assessments/".concat(userId, "/sections/start/").concat(startDate, "/end/").concat(endDate)).then(function (response) {
        if (response.status == 204) {
          resolve(null);
          return true;
        }

        resolve(response.data);
      });
    })
  };
};
export var getUserAssessmentStatisticsForProgress = function getUserAssessmentStatisticsForProgress(userId, start, end) {
  return {
    type: GET_USER_ASSESSMENTS_STATISTIC_PROGRESS,
    payload: new Promise(function (resolve) {
      api.get("assessments/".concat(userId, "/start/").concat(start, "/end/").concat(end, "/assessmentStatistics")).then(function (response, err) {
        resolve(response.data);
      });
    })
  };
};
export var getAssessmentsByStudentAndSection = function getAssessmentsByStudentAndSection(sectionId, studentId, startDate, endDate) {
  return {
    type: GET_ASSESSMENTS_BY_STUDENT_AND_SECTION,
    payload: new Promise(function (resolve) {
      api.get("assessments/section/".concat(sectionId, "/student/").concat(studentId, "/start/").concat(startDate, "/end/").concat(endDate, "/assessments")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getAssessmentsByStudent = function getAssessmentsByStudent(studentId, startDate, endDate) {
  return {
    type: GET_ASSESSMENTS_BY_STUDENT,
    payload: new Promise(function (resolve) {
      api.get("assessments/student/".concat(studentId, "/start/").concat(startDate, "/end/").concat(endDate, "/assessments")).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getUserSummary = function getUserSummary(studentId, startDate, endDate) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: GET_STUDENT_COURSES_GOALS,
    payload: new Promise(function (resolve) {
      var url = "assessments/v2/users/".concat(studentId, "/summary/data?startDate=").concat(startDate, "&endDate=").concat(endDate);

      if (params.courseId != null) {
        url += "&courseId=".concat(params.courseId);
      }

      if (params.sectionId != null) {
        url += "&sectionId=".concat(params.sectionId);
      }

      if (params.type != null) {
        url += "&type=".concat(params.type);
      }

      api.get(url).then(function (response) {
        resolve(response.data);
      });
    })
  };
};
export var getUserStatisticsDetailed = function getUserStatisticsDetailed(studentId, startDate, endDate) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: GET_STUDENT_ASSESSMENT_STATISTICS,
    payload: new Promise(function (resolve) {
      var url = "assessments/v2/users/".concat(studentId, "/statistics/detailed?startDate=").concat(startDate, "&endDate=").concat(endDate);

      if (params.sectionId != null) {
        url += "&sectionId=".concat(params.sectionId);
      }

      if (params.courseId != null) {
        url += "&courseId=".concat(params.courseId);
      }

      if (params.type != null) {
        url += "&type=".concat(params.type);
      }

      api.get(url).then(function (response) {
        resolve(response.data);
      });
    })
  };
};